import { injectable } from 'tsyringe';
import { LaporanKepesantrenan } from '../../../entities/LaporanKepesantrenan';
import { Endpoints } from '../../misc/Endpoints';
import ApiService from '../../services/ApiService';

@injectable()
export class LaporanKepesantrenanApiRepository {
  private apiService: ApiService;
  private endpoints: Endpoints;

  constructor(apiService: ApiService, endpoints: Endpoints) {
    this.apiService = apiService;
    this.endpoints = endpoints;
  }

  public async getList(
    page: number,
    rows: number,
    namaPesantren: string,
    peran: string,
  ): Promise<{ data: LaporanKepesantrenan[]; total: number }> {
    const headers = new Map<string, string>();
    const response = await this.apiService.invoke(
      'get',
      this.endpoints.laporanKepesantrenan(),
      { page, per_page: rows, nama_pesantren: namaPesantren || undefined, peran: peran || undefined },
      null,
      headers,
    );

    const paginated = response?.data?.data;
    const items: LaporanKepesantrenan[] = (paginated?.data ?? []).map(
      (d: any) =>
        new LaporanKepesantrenan(
          d.id,
          d.judul_pelatihan,
          d.nama_lengkap,
          d.nip_baru,
          d.nik,
          d.is_pesantren,
          d.nama_pesantren ?? null,
          d.nsp ?? null,
          d.alamat ?? null,
          d.nama_provinsi ?? null,
          d.nama_kabupaten ?? null,
          d.nama_kecamatan ?? null,
          d.peran ?? null,
          d.tahun_bergabung ?? null,
          d.status_mukim ?? null,
        ),
    );

    return { data: items, total: paginated?.total ?? 0 };
  }

  public async getPelatihanPesantren(): Promise<Array<{ id: number; judul_pelatihan: string }>> {
    const headers = new Map<string, string>();
    const response = await this.apiService.invoke(
      'get',
      this.endpoints.laporanKepesantrenanPelatihan(),
      {},
      null,
      headers,
    );
    return response?.data?.data ?? [];
  }

  public async getRekap(pelatihanId?: string): Promise<any> {
    const headers = new Map<string, string>();
    const params: Record<string, string> = {};
    if (pelatihanId) params.pelatihan_id = pelatihanId;
    const response = await this.apiService.invoke(
      'get',
      this.endpoints.laporanKepesantrenanRekap(),
      params,
      null,
      headers,
    );
    return response?.data?.data ?? null;
  }

  public async exportExcel(namaPesantren: string, peran: string): Promise<any> {
    const params: Record<string, string> = {};
    if (namaPesantren) params.nama_pesantren = namaPesantren;
    if (peran) params.peran = peran;

    return this.apiService.client.get(
      this.endpoints.laporanKepesantrenanExport(),
      { responseType: 'blob', params },
    );
  }
}
